import { render, staticRenderFns } from "./vertical-widget.vue?vue&type=template&id=d79c9668&"
import script from "./vertical-widget.vue?vue&type=script&lang=js&"
export * from "./vertical-widget.vue?vue&type=script&lang=js&"
import style0 from "./vertical-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports